module.exports = __webpack_public_path__ + "img/icon22.3cfed596.png";